import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/SubCategoryMaster.css";
import Table from "../Homepage/Table";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";
import AddServiceReportMapping from "./AddServiceReportMapping";
import SearchServiceReportMapping from "./SearchServiceReportMapping";

function ServiceReportMapping() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Boiler Head - Series", "Report Type", "Categories"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [servicemappingupdatedata, setservicemappingupdatedata] =
    useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [search, setSearch] = useState("");

  function fetchservicereportmappingdata(servicereportmappingid) {
    const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetSingleServiceReport/${servicereportmappingid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setservicemappingupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const fetchserviceReports = async () => {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetAllServiceReport/${pagenumber}`,
          {
            Search: search,
          }
        );
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.seriesGroup,
            x.type,
            x?.serviceReportMasterCategories?.length > 0
              ? x?.serviceReportMasterCategories
                  ?.map((x) => x.name)
                  .join(`, \n`)
              : "N/A",
          ])
        );
      } catch (error) {
        console.error(error);
      } finally {
        setloading(false);
      }
    };

    fetchserviceReports();
  }, [reload, pagenumber]);

  return (
    <section className="sub-category-master">
      <h1>Service Report Mapping</h1>
      <blockquote className="sub-category-master-forms">
        <AddMaster
          text="Add Service Report Mapping"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={() => false}
        />

        <SearchMaster
          text="Search Service Report Mapping"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddServiceReportMapping
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          servicemappingupdatedata={servicemappingupdatedata}
          key={`${servicemappingupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchServiceReportMapping
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchservicereportmappingdata}
        url="ServiceReportMaster/DeleteServiceReport"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={() => true}
        updatePermission={() => false}
        deletePermission={() => false}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default ServiceReportMapping;
